import React, {useEffect, useRef} from 'react';
import {SendHorizontal} from 'lucide-react';

const TextArea = ({text, setText, sendMessage, chatLoader, placeholder}: any) => {

    const ref: any = useRef(null);

    const handleInput: any = (e: any) => {
        if (!ref.current) return null
        ref.current.style.maxHeight = '42px';
        ref.current.style.maxHeight = Math.min(ref.current.scrollHeight, 200) + 'px';
        ref.current.style.height = Math.min(ref.current.scrollHeight, 200) + 'px';
        setText(e.target.value);
    };

    // Enter sends the message, Shift+Enter inserts a new line (ignored while composing with an IME)
    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key !== 'Enter' || e.shiftKey || e.nativeEvent.isComposing) return;
        e.preventDefault();
        if (!chatLoader) e.currentTarget.form?.requestSubmit();
    };

    // Shrink the textarea back after the message is sent
    useEffect(() => {
        if (!text.length && ref.current) {
            ref.current.style.height = '';
            ref.current.style.maxHeight = '';
        }
    }, [text]);

    const canSend = Boolean(text.trim()) && !chatLoader;

    return (
        <div className="PersonalChat__composer">
            <form onSubmit={sendMessage}
                  className="PersonalChat__chat_input">

                <label id={'messageInput'} className="label">
                    <textarea value={text} ref={ref} onInput={handleInput} onKeyDown={handleKeyDown} maxLength={400}
                              placeholder={placeholder || 'Message'} aria-label="Message" rows={1}/>
                </label>
                <button type="submit" disabled={!canSend} className="PersonalChat__send" aria-label="Send message">
                    <SendHorizontal size={18}/>
                </button>
            </form>
            <span className="PersonalChat__hint">Enter to send · Shift + Enter for a new line</span>
        </div>
    );
};

export default TextArea;
